"use client";

import React from 'react';
import StatsCard1 from './StatsCard1';
import StatsCard2 from './StatsCard2';
import StatsCardHover from './StatsCardHover';
const StatsSectionMentorship = ({
  brandLogos,
  isMobile
}: {
  brandLogos: {
    image: Image;
  }[];
  isMobile: boolean;
}) => {
  const statsData = [{
    title: "₹ 12,50,000+",
    subtitle: "Average annual CTC",
    icon: `/images/course-diff/rupee${isMobile ? 'm' : ''}.svg`,
    iconHover: `/images/course-diff/rupee-hover.svg`,
    iconStyle: {},
    iconStyleMobile: {
      marginTop: "-20px",
      marginBottom: "-20px"
    },
    width: 113,
    height: 97
  }, {
    title: "Top companies hiring in this industry",
    subtitle: "Get hired to work for these global giants",
    icon: ""
  }, {
    title: "Multiple projects",
    subtitle: "Learn by doing",
    icon: `/images/course-diff/folder${isMobile ? 'm' : ''}.svg`,
    iconHover: `/images/course-diff/folder-hover.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px"
    },
    iconStyleMobile: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    },
    width: 171,
    height: 93.25
  }, {
    title: "Secret insights",
    subtitle: "From real case-studies",
    icon: `/images/course-diff/papers${isMobile ? 'm' : ''}.svg`,
    iconHover: `/images/course-diff/papers-hover.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px"
    },
    iconStyleMobile: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    },
    width: 168,
    height: 100.25
  }, {
    title: "Live QnA sessions",
    subtitle: "talk with industry mentors",
    icon: `/images/course-diff/screen${isMobile ? 'm' : ''}.svg`,
    iconHover: `/images/course-diff/screen-hover.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px"
    },
    iconStyleMobile: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    },
    width: 113,
    height: 91.25
  }];
  const gridDataDesktop = [{
    gridRow: "1",
    gridColumn: "1"
  }, {
    gridRow: "1 / span 2",
    gridColumn: "2"
  }, {
    gridRow: "1",
    gridColumn: "3"
  }, {
    gridRow: "2",
    gridColumn: "1"
  }, {
    gridRow: "2",
    gridColumn: "3"
  }];
  const gridDataMobile = [{
    gridRow: "1",
    gridColumn: "1"
  }, {
    gridRow: "2 / span 2",
    gridColumn: "1"
  }, {
    gridRow: "4",
    gridColumn: "1"
  }, {
    gridRow: "5",
    gridColumn: "1"
  }, {
    gridRow: "6",
    gridColumn: "1"
  }];
  const gridData = isMobile ? gridDataMobile : gridDataDesktop;
  const spanData = [{
    cell: 1,
    cardVariant: 2
  }];
  return <div className="section__container--small" data-sentry-component="StatsSectionMentorship" data-sentry-source-file="StatsSectionMentorship.tsx">
      <div className="stats-section">
        {statsData.map((stat, index) => {
        for (let i = 0; i < spanData.length; i++) {
          if (spanData[i].cell === index) {
            switch (spanData[i].cardVariant) {
              case 2:
                return <StatsCard2 key={index} cardStyle={{
                  backgroundColor: "#FFFAF1"
                }} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} logos={brandLogos} />;
            }
          }
        }
        if (!isMobile) return <StatsCardHover key={index} cardStyle={{
          backgroundColor: "#FFFAF1"
        }} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} iconHover={stat.iconHover} iconStyle={stat.iconStyle} gridStyle={gridData[index]} wid={stat.width} hei={stat.height} />;
        return <StatsCard1 key={index} cardStyle={{
          backgroundColor: "#FFFAF1"
        }} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} iconStyle={stat.iconStyleMobile} gridStyle={gridData[index]} />;
      })}
      </div>
    </div>;
};
export default StatsSectionMentorship;